import {DqlQuery, Query} from '../field';
import {OutgoingSms as OutgoingSmsNS} from '../../sms/outgoing/task-record-outgoing-sms.service';
import {SmsTemplate} from "../../sms/sms-template/sms-template.service";

export class OutgoingSms {

  readonly id: Query.NumberField;
  readonly messageId: Query.StringField;
  readonly content: Query.StringField;
  readonly deliveryTime: Query.DateTimeField;
  readonly recipient: Query.StringField;
  readonly state: Query.EnumField<OutgoingSmsNS.SmsState>;
  readonly sendMode: Query.EnumField<OutgoingSmsNS.SmsSendMode>;
  readonly bipState: Query.EnumField<OutgoingSmsNS.BipSmsState>;
  readonly integrationType: Query.EnumField<SmsTemplate.SmsIntegrationType>;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.NumberField(prefix + 'id');
    this.messageId = new DqlQuery.StringField(prefix + 'message_id');
    this.content = new DqlQuery.StringField(prefix + 'content');
    this.deliveryTime = new DqlQuery.DateTimeField(prefix + 'delivery_time');
    this.recipient = new DqlQuery.StringField(prefix + 'recipient');
    this.state = new DqlQuery.EnumField(prefix + 'state', T => T);
    this.sendMode = new DqlQuery.EnumField(prefix + 'send_mode', T => T);
    this.bipState = new DqlQuery.EnumField(prefix + 'bip_state', T => T);
    this.integrationType = new DqlQuery.EnumField(prefix + 'integration_type', T => T);
  }

}
